var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionBottles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C7.44772 0 7 0.447708 7 1V2H10C10.5523 2 11 2.44772 11 3V4C11.5523 4 12 4.44772 12 5V6H13V12H11V14H14C14.5523 14 15 13.5523 15 13V12V6C15.5523 6 16 5.55229 16 5V3C16 2.44771 15.5523 2 15 2V1C15 0.447708 14.5523 0 14 0H8ZM9 5V6C9.55 6 10 6.45 10 7V9C10 9.55 9.55 10 9 10V15C9 15.55 8.55 16 8 16H2C1.45 16 1 15.55 1 15V10C0.45 10 0 9.55 0 9V7C0 6.45 0.45 6 1 6V5C1 4.45 1.45 4 2 4H8C8.55 4 9 4.45 9 5ZM5 11H7V10H3V14H7V13H5V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionBottles);
export default __webpack_public_path__ + "static/media/prescriptionBottles.23fa6c7bba190f40576f2b93e9dd4407.svg";
export { ForwardRef as ReactComponent };